/* global window, document */
// eslint-disable-next-line no-redeclare
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import AdminApp from './AdminApp.js';
import WebApp from './WebApp.js';
import store from './store';

// eslint-disable-next-line no-underscore-dangle
if (!window._babelPolyfill) {
  // eslint-disable-next-line global-require
  require('@babel/polyfill');
}

document.addEventListener('DOMContentLoaded', () => {
  const shortcodeContainers = document.querySelectorAll('.wp-reactivate-shortcode');

  for (let i = 0; i < shortcodeContainers.length; ++i) {
    const objectId = shortcodeContainers[i].getAttribute('data-object-id');

    if(rmVars.isAdmin) {
      ReactDOM.render(<Provider store={store}><AdminApp wpObject={window[objectId]} /></Provider>, shortcodeContainers[i]);
    } else {
      ReactDOM.render(<Provider store={store}><WebApp wpObject={window[objectId]} /></Provider>, shortcodeContainers[i]);
    }
  }
});
